export const API_URL = import.meta.env.VITE_API_URL as string;
export const PUBLIC_KEY = import.meta.env.VITE_PUBLIC_KEY as string;
export const NOTIFICATION_URL = import.meta.env.VITE_NOTIFICATION_URL as string;

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string;

export const REACT_APP_BUS_CODE = 1;
export const REACT_APP_LINE_CODE = 1;
